import { DisclosureTooltip } from '@ria-client/tw-shared-ui';
import { CircleHelp } from 'lucide-react';

export interface ApyDriverProps {
  termLength: string;
  termLengthValue: string;
  valueTooltip?: string;
}

export function ApyDriver({ termLength, termLengthValue, valueTooltip }: ApyDriverProps) {
  return (
    <span>
      {`${termLength} ${termLengthValue}`}
      <span className="whitespace-nowrap align-top">
        {' '}
        {valueTooltip && (
          <DisclosureTooltip
            trigger={
              <button
                aria-label={`${termLength} info`}
                className="inline-flex align-middle"
                type="button"
              >
                <CircleHelp aria-hidden size={24} />
              </button>
            }
          >
            <span className="typography-text-small">{valueTooltip}</span>
          </DisclosureTooltip>
        )}
      </span>
    </span>
  );
}
